import { useQuery } from '@tanstack/react-query';

import { type Whoami } from '@/types/whoami';
import { domainMeta } from '@/utils/domain-meta';

const fetchWhoami = async (): Promise<Whoami | null> => {
  const res = await fetch(
    `${domainMeta.monolithOrigin}/api_self_serve/v1/whoami?origin=source`,
    { credentials: 'include' },
  );

  if (res.status === 401) return null;
  if (!res.ok) throw new Error('Failed to fetch user');

  const data = (await res.json()) as Whoami;
  return data;
};

export const useAuth = () => {
  return useQuery({
    queryKey: ['whoami'],
    queryFn: fetchWhoami,
    retry: false,
  });
};
